import React, { Component } from 'react'
import { connect } from "react-redux"
import trans from "trans";

import { selectFormValues } from "app/reducers/form"

import {
    css,
    GridCell,
    InputGroup,
    Grid,
    TextInput,
    Range,
} from "@bdfx/mergado-ui-kit"

import {
    updateInputValue as change,
} from "app/reducers/form";

import { getElementValue} from "./helpers";

import { Project, Template } from "app/types/model-types"
import EditLayout from "template-edit/components/edit-layout"
import { RandomProduct } from 'shape-edit/types'

interface Props {
    isAlt: boolean
    templateForm: Template
    project: Project
    randomProduct: RandomProduct
    change: typeof change
    showOverlap: boolean
    setShowOverlap: Function
    handleImageRefresh: Function
}

class SourceImageLayoutForm extends Component<Props> {
    constructor(props) {
        super(props);
    }

    render() {
        const { project, randomProduct, isAlt, templateForm } = this.props

        const item_id_element = project?.e_item_id || 'ITEM_ID'
        const item_id = item_id_element ? getElementValue(randomProduct.serialized_data, item_id_element) : null

        const isMatching = templateForm.random_product_id && randomProduct?.id && (
            (`${templateForm.random_product_id}` === `${randomProduct.id}`) ||
            (`${templateForm.random_product_id}` === `${item_id}`)
        )

        return (
            <React.Fragment>
                {!isAlt &&
                    <React.Fragment>
                        <GridCell className="step">3.a</GridCell>
                        <GridCell className="title">{trans("main_image_or_collage")}</GridCell>

                        <GridCell className="content" col={"1 / -1"}>
                            <InputGroup
                                orientation="horizontal"
                                singleChoice={true}
                                value={templateForm.is_anim_gif ? 'anim_gif' : (templateForm.is_collage ? 1 : 0)}
                                style={{
                                    ".m-radio-wrapper.m-isinvalid": {
                                        gridTemplateColumns: "1fr 1fr 1fr",
                                        gridAutoFlow: "unset",
                                    }
                                }}
                                onChange={(value) => {
                                    switch (value) {
                                        case 0:
                                            this.props.change('templateForm', 'is_collage', 0)
                                            this.props.change('templateForm', 'is_anim_gif', 0)
                                            break
                                        case 1:
                                            this.props.change('templateForm', 'is_collage', 1)
                                            this.props.change('templateForm', 'is_anim_gif', 0)
                                            break
                                        case 'anim_gif':
                                            this.props.change('templateForm', 'is_collage', 1)
                                            this.props.change('templateForm', 'is_anim_gif', 1)
                                            break
                                    }
                                }}
                                items={[
                                    { value: 0, label: trans('main_image_opt') },
                                    { value: 1, label: trans('layout_opt') },
                                    { value: "anim_gif", label: trans('is_anim_gif') + ' (BETA)' },
                                ]}
                            />
                        </GridCell>
                    </React.Fragment>
                }

                <GridCell className="content" col={"1 / -1"}>
                    {!!templateForm.is_anim_gif &&
                        <React.Fragment>
                            <Range
                                label={trans('frames_delay')}
                                min={1e+2}
                                max={1e+4}
                                step={10}
                                onClear={() => this.props.change('templateForm', 'frames_delay', null)}
                                name={'templateForm.frames_delay'}
                                defaultValue={1e+2}
                            />

                            <Range
                                label={trans('loops_delay')}
                                min={1e+2}
                                max={1e+4}
                                step={10}
                                onClear={() => this.props.change('templateForm', 'loops_delay', null)}
                                name={'templateForm.loops_delay'}
                                defaultValue={1e+2}
                            />
                        </React.Fragment>
                    }

                    {!!templateForm.is_collage &&
                        <EditLayout isEditTemplateMode={true} />
                    }
                </GridCell>
            </React.Fragment >
        )
    }
}

const StyledRandomProductGrid = css(Grid)({
    gridTemplateColumns: '1fr 1fr',
    gridGap: '20px',
    padding: '10px',
    ' .muk-gridcell': {
        alignSelf: 'center'
    }
})

function mapStateToProps(state) {
    return {
        isAlt: state.isAlt,
        templateForm: selectFormValues(state, 'templateForm'),
        project: state.project,
        randomProduct: state.randomProduct,
    }
}

export default connect(mapStateToProps, {
    change,
})(SourceImageLayoutForm)
